import axios from 'axios';
import authHeader from './auth-header';
import { API_URL, CHAT_API_URL } from './config';
import AuthService from './auth.service';

// Create axios instance for chat with interceptors
const chatClient = axios.create({
  baseURL: CHAT_API_URL,
});

// Response interceptor to handle token expiration for chat
chatClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or unauthorized
      console.log('Chat: Token expired or unauthorized, logging out user');
      AuthService.logout();
      // Redirect to login page
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

const ChatService = {
  async openConversation() {
    const res = await chatClient.post('conversations/open', {}, { headers: authHeader() });
    return res.data;
    },
  async listConversations() {
    const res = await chatClient.get('conversations', { headers: authHeader() });
    return res.data;
  },
  async getMessages(conversationId, params = {}) {
    const res = await chatClient.get(`conversations/${conversationId}/messages`, { params, headers: authHeader() });
    return res.data;
  },
  async sendMessage(conversationId, content) {
    const res = await chatClient.post(`conversations/${conversationId}/messages`, { content }, { headers: authHeader() });
    return res.data;
  },
  async upload(conversationId, file) {
    const form = new FormData();
    form.append('file', file);
    const res = await chatClient.post(`conversations/${conversationId}/attachments`, form, { headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' } });
    return res.data;
  },
  async markRead(conversationId) {
    const res = await chatClient.post(`conversations/${conversationId}/read`, {}, { headers: authHeader() });
    return res.data;
  },
  async assignAdmin(conversationId) {
    const res = await chatClient.post(`conversations/${conversationId}/assign`, {}, { headers: authHeader() });
    return res.data;
  },
  async closeConversation(conversationId) {
    const res = await chatClient.put(`conversations/${conversationId}/close`, {}, { headers: authHeader() });
    return res.data;
  },
  async getUnreadCounts() {
    const res = await chatClient.get('unread-counts', { headers: authHeader() });
    return res.data;
  },
  async initiateChatWithUser(userId) {
    const res = await chatClient.post(`initiate/${userId}`, {}, { headers: authHeader() });
    return res.data;
  },
  async deleteChatHistory(userId) {
    const res = await chatClient.delete(`history/${userId}`, { headers: authHeader() });
    return res.data;
  }
};

export default ChatService;